import { useAuth } from "contexts/AuthContext";
import { useRef, useState } from "react";
import { userService } from "api";
import ProfilePicture from "./ProfilePicture";

export default function ProfileCard() {
    const { user } = useAuth();
    const [uploadError, setUploadError] = useState<string | null>(null);
    const hasProfilePicture = Boolean(user?.profilePictureUrl);

    console.log(hasProfilePicture);
    console.log(user?.profilePictureUrl);
    return (
        <div className="col-md-4">
            <div className="card mb-4">
                <div className="card-body text-center">
                    <div className="profile-photo mb-3 position-relative">
                        <ProfilePicture width={150} height={150} fallbackSize="4x" />
                        <ProfilePictureOperations hasProfilePicture={hasProfilePicture} />
                    </div>
                    {uploadError && (
                        <div className="alert alert-danger py-2 small mb-2" role="alert">
                            {uploadError}
                        </div>
                    )}
                    <h5 className="card-title">{user?.firstName} {user?.lastName}</h5>
                    <p className="text-muted">{user?.email}</p>
                </div>
            </div>
        </div>
    );
}

function ProfilePictureOperations({ hasProfilePicture }: { hasProfilePicture: boolean }) {
    const { user, refreshUser } = useAuth();
    const [uploading, setUploading] = useState(false);
    const [uploadError, setUploadError] = useState<string | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handlePhotoChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file || !user?.id) return;
        setUploadError(null);
        setUploading(true);
        try {
            const result = await userService.uploadProfilePicture(file);
            if (result.isSuccess) {
                await refreshUser();
            } else {
                setUploadError(result.message ?? 'Profil fotoğrafı yüklenemedi.');
            }
        } catch {
            setUploadError('Profil fotoğrafı yüklenirken bir hata oluştu.');
        } finally {
            setUploading(false);
            e.target.value = '';
        }
    };

    const handleRemovePhoto = async () => {
        if (!user?.id) return;
        setUploadError(null);
        setUploading(true);
        try {
            const result = await userService.deleteProfilePicture();
            if (result.isSuccess) {
                await refreshUser();
            } else {
                setUploadError(result.message ?? 'Profil fotoğrafı kaldırılamadı.');
            }
        } catch {
            setUploadError('Profil fotoğrafı kaldırılırken bir hata oluştu.');
        } finally {
            setUploading(false);
        }
    };

    if (!hasProfilePicture) {
        return (
            <div>
                <button
                    className="photo-edit-icon"
                    title="Fotoğraf yükle"
                    style={{ pointerEvents: uploading ? 'none' : undefined }}
                    onClick={() => fileInputRef.current?.click()}
                >
                    <i className="fas fa-camera"></i>
                </button>
                <input
                    ref={fileInputRef}
                    type="file"
                    className="d-none"
                    accept="image/*"
                    onChange={handlePhotoChange}
                    disabled={uploading}
                />
            </div>
        );
    }

    return (
        <div className="dropdown" style={{ position: 'absolute', bottom: 0, right: '10px' }}>
            <button
                className="photo-edit-icon"
                title="Fotoğraf işlemleri"
                style={{
                    position: 'relative',
                    bottom: 'auto',
                    right: 'auto',
                    pointerEvents: uploading ? 'none' : undefined,
                }}
                data-bs-toggle="dropdown"
                aria-expanded="false"
                id="profilePhotoDropdownToggle"
            >
                <i className="fas fa-camera"></i>
            </button>
            <ul
                className="dropdown-menu dropdown-menu-end profile-photo-dropdown"
                aria-labelledby="profilePhotoDropdownToggle"
                style={{
                    borderTop: '3px solid #0d6efd',
                    minWidth: '110px',
                    minHeight: '50px',
                    padding: 0,
                }}
            >
                <li
                    className="dropdown-action-item"
                    style={{
                        width: '50px',
                        height: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: uploading ? 'not-allowed' : 'pointer',
                        borderRadius: '8px',
                        transition: 'background 0.2s',
                    }}
                >
                    <label
                        htmlFor="profilePhotoInput"
                        style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: 0,
                            cursor: uploading ? 'not-allowed' : 'pointer',
                        }}
                        title="Fotoğraf yükle"
                    >
                        <i className="fas fa-camera" style={{ fontSize: '1.4rem' }} />
                    </label>
                    <input
                        id="profilePhotoInput"
                        type="file"
                        className="d-none"
                        accept="image/*"
                        onChange={handlePhotoChange}
                        disabled={uploading}
                    />
                </li>
                <li
                    className="dropdown-action-item"
                    style={{
                        width: '50px',
                        height: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: uploading ? 'not-allowed' : 'pointer',
                        borderRadius: '8px',
                        transition: 'background 0.2s',
                    }}
                >
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-danger rounded-circle p-0"
                        style={{
                            width: '36px',
                            height: '36px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: 'none',
                            background: 'transparent',
                        }}
                        onClick={handleRemovePhoto}
                        disabled={uploading}
                        title="Fotoğrafı kaldır"
                        aria-label="Fotoğrafı kaldır"
                    >
                        <i className="fas fa-times" style={{ fontSize: '1.3rem' }}></i>
                    </button>
                </li>
                <style>
                    {`
                        .profile-photo-dropdown.show {
                            display: flex !important;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            gap: 4px;
                        }
                        .dropdown-action-item:hover {
                            background: #f0f7ff;
                        }
                        .dropdown-action-item:active {
                            background: #e4eaff;
                        }
                        .dropdown-action-item:disabled,
                        .dropdown-action-item[aria-disabled="true"] {
                            pointer-events: none;
                            opacity: 0.6;
                        }
                        .dropdown-action-item label:active,
                        .dropdown-action-item button:active {
                            background: transparent;
                        }
                    `}
                </style>
            </ul>
        </div>
    );
}